var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.449 13.163c.295.63 1.037 1.891 1.037 1.891l8.49-14.052L15.98 1 7.71 6.785c-.518.332-.888.775-1.184 1.292a5.887 5.887 0 0 0-.597 2.592c0 .847.176 1.697.52 2.494zM3.11 17.761a9.47 9.47 0 0 0 3.71 6.862L15.98 31s-.36-.517-.974-1.42c-1.843-2.712-5.98-8.908-9.596-15.082a8.222 8.222 0 0 1-.964-2.818 4.033 4.033 0 0 1 0-1.335 32.966 32.966 0 0 1-.37.704 11.833 11.833 0 0 0-1.002 3.189 15.962 15.962 0 0 0 .037 3.521zm22.446-.57c.222.384.695 1.211.917 1.684.093.204.174.411.242.621.48 1.47.37 3.064-.279 4.46a3.98 3.98 0 0 1-1.187 1.298L16.943 31l8.492-14.017s.047.079.12.207zm4.292-2.951a9.47 9.47 0 0 0-3.708-6.862L16.98 1s.36.517.974 1.42c1.842 2.712 5.98 8.908 9.595 15.082a8.224 8.224 0 0 1 .989 2.985c.047.39.039.779-.026 1.168l.048-.094c.125-.24.324-.61.324-.61a12.08 12.08 0 0 0 1.001-3.152l.013-.22a22.417 22.417 0 0 0-.05-3.34z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEns);
export default __webpack_public_path__ + "static/media/ENS.d825ad4e437832e75945eab1ae7885ed.svg";
export { ForwardRef as ReactComponent };